import { IconButton } from '@civilgrid/ui/components';
import { useSnapshot } from 'valtio';
import { useVisualizeGeoreferencedMapsEnabled } from '~/hooks/useVisualizeGeoreferencedMapsEnabled';
import layerStore from '~/store2/layers';
import { GEOREFERENCED_MAPS_PANEL_ID } from './panelIds';

/** Opens the Geo-referenced Maps panel; shown only when the flag is on and the project has maps. */
export const GeoreferencedMapsButton = () => {
  const { enabled } = useVisualizeGeoreferencedMapsEnabled();
  const { isGeoreferencedMapsPanelVisible, georeferencedMapsTOCGroup } = useSnapshot(layerStore) as typeof layerStore;

  if (!enabled || georeferencedMapsTOCGroup.length === 0) return null;

  return (
    <IconButton
      data-testid="georeferenced-maps-button"
      icon="file"
      variant="secondary"
      aria-haspopup="dialog"
      aria-expanded={isGeoreferencedMapsPanelVisible}
      aria-controls={isGeoreferencedMapsPanelVisible ? GEOREFERENCED_MAPS_PANEL_ID : undefined}
      onClick={() => layerStore.toggleGeoreferencedMapsPanel()}
    >
      Geo-referenced Maps
    </IconButton>
  );
};
